const ShowMore = {
  mounted() {
    const target = document.getElementById(this.el.getAttribute('data-show-via'))
    const container = this.el
    const containerRect = container.getBoundingClientRect()

    if (containerRect.height > 100) {
      container.classList.add('h-[100px]')
      container.classList.add('overflow-hidden')
      target.classList.remove('hidden')
    }
  },
}

export default ShowMore
